import clsx from "clsx";
import { formatTimeStampToDateAndTime } from "utils/HelperFunctions";

type Props = {
  image: string;
  title: string;
  description: string;
  createdAt: string;
  additionalClasses?: string;
  handleMarkNotificationAsReadAndNavigateToCta: () => void;
};

function NotificationCardForPage({
  image,
  description,
  title,
  additionalClasses,
  createdAt,
  handleMarkNotificationAsReadAndNavigateToCta,
}: Props) {
  return (
    <button
      type="button"
      onClick={handleMarkNotificationAsReadAndNavigateToCta}
      className={clsx(
        "flex items-start rounded-ll border text-start",
        "cursor-pointer border-white bg-primary p-2 2xl:p-3",
        additionalClasses,
      )}
    >
      <img
        className="mr-2 h-14 w-14 rounded-lg border border-white  object-cover 2xl:mr-4 2xl:h-16 2xl:w-16"
        src={image}
        alt={title}
      />
      <div className="my-auto">
        <p
          className="font-satoshi text-xs font-semibold  leading-5 text-white line-clamp-2
         xl:mb-0 2xl:mb-1 2xl:text-sm"
        >
          {title}
        </p>
        {/* Html will be recieved for the heading */}
        <p
          className="font-satoshi text-xs font-450 leading-5 text-white xl:mb-0 2xl:mb-1 2xl:text-sm"
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ __html: description }}
        />
        <div className="font-satoshi text-xxs font-450 leading-5 text-white text-opacity-50 2xl:text-xs">
          {formatTimeStampToDateAndTime(createdAt)}
        </div>
      </div>
    </button>
  );
}
export default NotificationCardForPage;
